export default "__VITE_ASSET__Ch9B4hgF__"